import { useRef, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';

import config from 'src/config';

import videojs from 'video.js';

import 'react-multi-carousel/lib/styles.css';
import 'video.js/dist/video-js.css';
import SimpleStepSectionStyle from './style';

const SimpleStepSection = () => {
  const { t } = useTranslation('business');
  const { t: tCommon } = useTranslation('common');
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const videoRef = useRef(null);
  const playerRef = useRef<videojs.Player>();

  const handleClick = (index: number) => {
    setSelectedIndex(index);
  };

  const getSource = (index: number) =>
    `${config.IMAGE_CDN_HOST}/assets/b2b-landing/three-simple-step-video/${index}.mp4`;

  useEffect(() => {
    const player: any = playerRef.current;
    if (player) {
      player.src({
        src: getSource(selectedIndex + 1),
        type: 'video/mp4',
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    const videoElement = videoRef.current;
    const options = {
      playsinline: true,
      controls: true,
      autoplay: true,
      muted: true,
      responsive: true,
      fluid: true,
      loop: true,
    };

    if (videoElement) {
      playerRef.current = videojs(videoElement, options);
    }

    setSelectedIndex(0);
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
      }
    };
  }, []);

  return (
    <SimpleStepSectionStyle>
      <div className="container">
        <Typography className="title-eng">{t('simple_step_subtitle')}</Typography>
        <Typography className="title">{t('simple_step_title')}</Typography>
        <Typography className="subtitle">{t('simple_step_description')}</Typography>
        <Typography className="subtitle">{t('simple_step_description_more')}</Typography>

        <Grid container alignItems="center" className="content-container">
          <Grid item lg={6} sm={4} xs={12} className="menu">
            <Box className={`menu-item ${selectedIndex === 0 ? 'active' : ''}`} onClick={() => handleClick(0)}>
              <span>{tCommon('login')}</span>
            </Box>
            <Box className={`menu-item ${selectedIndex === 1 ? 'active' : ''}`} onClick={() => handleClick(1)}>
              <span>{tCommon('choose_course')}</span>
            </Box>
            <Box className={`menu-item ${selectedIndex === 2 ? 'active' : ''}`} onClick={() => handleClick(2)}>
              <span>{tCommon('start_learn')}</span>
            </Box>
          </Grid>
          <Grid item lg={6} sm={8} xs={12}>
            <div data-vjs-player>
              <video ref={videoRef} className="video-js vjs-big-play-centered" />
            </div>
          </Grid>
        </Grid>
      </div>
    </SimpleStepSectionStyle>
  );
};

export default SimpleStepSection;
